import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const store = {
  namespaced: true,

  state: {
    history: [],
    profiles: {},

    fudaoDto: {},
    fudaoSession: {},
    responseTimeout: 15000,
    isFudaoConnected: false,
    fudaoPassedTime: 0
  },
  mutations,
  actions,
  getters
};

export default store;
